var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHrdotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more-horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.3871 10.1612C9.81467 10.1612 10.1613 9.81456 10.1613 9.38699C10.1613 8.95941 9.81467 8.61279 9.3871 8.61279C8.95952 8.61279 8.6129 8.95941 8.6129 9.38699C8.6129 9.81456 8.95952 10.1612 9.3871 10.1612Z",
    stroke: "black",
    strokeWidth: 1.54839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.8065 10.1612C15.234 10.1612 15.5806 9.81456 15.5806 9.38699C15.5806 8.95941 15.234 8.61279 14.8065 8.61279C14.3789 8.61279 14.0323 8.95941 14.0323 9.38699C14.0323 9.81456 14.3789 10.1612 14.8065 10.1612Z",
    stroke: "black",
    strokeWidth: 1.54839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.96774 10.1612C4.39532 10.1612 4.74194 9.81456 4.74194 9.38699C4.74194 8.95941 4.39532 8.61279 3.96774 8.61279C3.54017 8.61279 3.19355 8.95941 3.19355 9.38699C3.19355 9.81456 3.54017 10.1612 3.96774 10.1612Z",
    stroke: "black",
    strokeWidth: 1.54839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrdotes);
export default __webpack_public_path__ + "static/media/hrdotes.aab14b243d7d3b4363eca1c033a0c571.svg";
export { ForwardRef as ReactComponent };